export default "__VITE_ASSET__afadd817__"